import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Platform } from '@ionic/angular';
import { VhViethasWebAPPEndUser } from 'vhwebapp';
import * as DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-webapp-home-fields-c001-user',
  templateUrl: './webapp-home-fields-c001-user.component.html',
  styleUrls: ['./webapp-home-fields-c001-user.component.scss']
})
export class WebappHomeFieldsC001UserComponent implements OnInit {
  routeParams: any
  isLoading: boolean = false
  data_home: any
  isMobile: boolean;
  public onReady(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
  }

  public EDITOR = DecoupledEditor;
  config: any = {
    ckfinder: {
      options: {
        language: 'en',
        resourceType: 'Images',
        readonly: true,
      },
    },
  };

  constructor(
    public platform: Platform,
    private vhViethasWebAPPEndUser: VhViethasWebAPPEndUser,
    private route: ActivatedRoute,
    public titleService: Title,
    public metaTagService: Meta
  ) {
    if (this.platform.is('desktop')) this.isMobile = false;
    else this.isMobile = true;
  }

  ngOnInit(): void {
    this.getDataField()
  }

  getDataField() {
    this.isLoading = true
    this.route.params.subscribe(routeParams => {
      this.routeParams = routeParams
      console.log(routeParams)

      this.vhViethasWebAPPEndUser.getComponentContent('webapp_fields_c001s', routeParams.id_field)
        .then((response: any) => {
          console.log(response)
          if (response.vcode === 0 && response.data.length != 0) {
            //-----------your code-----------
            this.data_home = response.data;
            this.titleService.setTitle(this.data_home.name + ' ' + '- Viethas cung cấp tất cả thiết bị bán hàng chuyên dụng');
            this.metaTagService.updateTag({ name: 'description', content: 'Thiết bị bán hàng chuyên dụng, máy in mã vạch, máy in nhiệt, máy cnc mini' },)
            this.isLoading = false
          } else {
            this.isLoading = false
          }
        }, error => {
          this.isLoading = false
          console.log('error', error);
        })
    })
  }
  //** định dạng tên theo dạng a-b-c truyền vào url */
  formatName(_value) {
    return _value.split('-').join(" ")
  }
}
